class ProductDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    const closeBtn = this.querySelector('.pd-product-drawer__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', this.close.bind(this));
    }
    
    // Click outside to close
    this.addEventListener('click', (event) => {
      const target = event.target;
      const inner = this.querySelector('.pd-product-drawer__inner');
    
      if (!inner.contains(target)) {
        this.close();
      }
    });
    
    this.initTriggers();
  }
  
  initTriggers() {
    const triggers = document.querySelectorAll('[data-drawer-trigger]');
    
    triggers.forEach(trigger => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const contentId = trigger.getAttribute('data-drawer-content-id');
        const heading = trigger.getAttribute('data-drawer-heading');
        const drawerClass = trigger.getAttribute('data-drawer-class');
        this.open(contentId, heading, trigger, drawerClass);
      });
    });
  }
  
  open(contentId, heading, triggeredBy, drawerClass) {
    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
    }

    // Add custom class if provided
    if (drawerClass) {
      this.drawerClass = drawerClass;
      this.classList.add(drawerClass);
    }
    
    // Inject heading
    const headingElement = this.querySelector('.pd-product-drawer__heading');
    if (headingElement && heading) {
      headingElement.textContent = heading;
    }
    
    // Inject content from template
    const template = document.getElementById(contentId);
    const contentContainer = this.querySelector('.pd-product-drawer__content');
    
    if (template && contentContainer && template instanceof HTMLTemplateElement) {
      // Clone template content
      const content = template.content.cloneNode(true);
      
      // Clear existing content
      contentContainer.innerHTML = '';
      
      // Append new content
      contentContainer.appendChild(content);
    }
    
    // Add active class with slight delay for animation
    setTimeout(() => {
      this.classList.add('active');
    }, 10);
    
    // Trap focus
    this.addEventListener(
      'transitionend',
      () => {
        const focusElement = this.querySelector('.pd-product-drawer__inner');
        trapFocus(this.querySelector('.pd-product-drawer__inner'), focusElement);
      },
      { once: true }
    );
    
    // Disable body scroll
    document.body.classList.add('overflow-hidden');
  }
  
  close() {
    // Remove active class and custom drawer class
    this.classList.remove('active');
    if (this.drawerClass) {
      this.classList.remove(this.drawerClass);
      this.drawerClass = null;
    }
    
    // Remove focus trap
    removeTrapFocus(this.activeElement);
    
    // Re-enable body scroll
    document.body.classList.remove('overflow-hidden');
    
    // Clear content after animation
    setTimeout(() => {
      const contentContainer = this.querySelector('.pd-product-drawer__content');
      const headingElement = this.querySelector('.pd-product-drawer__heading');
      
      if (contentContainer) {
        contentContainer.innerHTML = '';
      }
      
      if (headingElement) {
        headingElement.textContent = '';
      }
    }, 300);
  }
  
  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('product-drawer', ProductDrawer);
